import { render, staticRenderFns } from "./addAssignees.vue?vue&type=template&id=7b6e707a&"
import script from "./addAssignees.vue?vue&type=script&lang=js&"
export * from "./addAssignees.vue?vue&type=script&lang=js&"
import style0 from "./addAssignees.vue?vue&type=style&index=0&id=7b6e707a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports